import { __decorate } from 'tslib';
import { NgModule, EventEmitter, ɵɵdefineInjectable, Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';
import { fromEvent } from 'rxjs';
import { debounceTime, startWith } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
let NgConnectionModule = class NgConnectionModule {
};
NgConnectionModule.ɵfac = function NgConnectionModule_Factory(t) { return new (t || NgConnectionModule)(); };
NgConnectionModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgConnectionModule });
NgConnectionModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });

let NgConnection = class NgConnection {
    constructor() {
        this.statusEmitter = new EventEmitter();
        this.isConnected = navigator.onLine;
        this.trackingConnection();
    }
    trackingConnection() {
        this.online$ = fromEvent(window, 'online');
        this.offline$ = fromEvent(window, 'offline');
        this.online$.subscribe(_ => {
            this.isConnected = true;
            this.emitNetworkStatus();
        });
        this.offline$.subscribe(_ => {
            this.isConnected = false;
            this.emitNetworkStatus();
        });
    }
    emitNetworkStatus() {
        this.statusEmitter.emit(this.isConnected);
    }
    connectivity(showCurrentStatus = true) {
        return showCurrentStatus
            ? this.statusEmitter.pipe(debounceTime(300), startWith(this.isConnected))
            : this.statusEmitter.pipe(debounceTime(300));
    }
};
NgConnection.ɵfac = function NgConnection_Factory(t) { return new (t || NgConnection)(); };
NgConnection.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NgConnection, factory: function (t) { return NgConnection.ɵfac(t); }, providedIn: 'root' });
NgConnection.ngInjectableDef = ɵɵdefineInjectable({ factory: function NgConnection_Factory() { return new NgConnection(); }, token: NgConnection, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgConnectionModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgConnectionModule, { imports: function () { return [CommonModule]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgConnection, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { NgConnection, NgConnectionModule };

